// extracted by mini-css-extract-plugin
export var gallery = "Gallery-module--gallery--30_O1";
export var slideshow = "Gallery-module--slideshow--31Sf_";
export var photo = "Gallery-module--photo--wWVZH";